<template>
  <div class="modal fade" id="options-dialog" tabindex="-1" aria-labelledby="optionsDialogLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-3">
        <div class="modal-header">
          <h5 class="modal-title" id="optionsDialogLabel">Options</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div 
            v-for="option in sortedOptions" 
            :key="option.type"
            class="option-item"
            :class="{ 'pro-item': option.isPro }"
            @click="option.action"
          >
            <div class="option-content">
              <span v-if="option.isPro" class="pro-badge">PRO+</span>
              <span class="option-text">{{ option.name }}</span>
            </div>
            <span class="material-icons option-icon">{{ option.icon }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue';
import { OptionItem } from '../../utils/models/OptionItem';

export default defineComponent({
  name: 'Options',
  props: {
    options: {
      type: Array as PropType<OptionItem[]>,
      required: true
    }
  },
  setup(props) {
    const sortedOptions = computed(() => {
      // Sort options: non-pro first, then pro
      return [...props.options].sort((a, b) => {
        if (a.isPro === b.isPro) return 0;
        return a.isPro ? 1 : -1;
      });
    });

    return {
      sortedOptions
    };
  }
});
</script>

<style scoped>
.modal-content {
  color: #ffffff;
  border: none;
  border-radius: 8px;
}

.modal-header {
  border-bottom: none;
}

.modal-title {
  font-weight: 600;
}

.btn-close {
  opacity: 0.8;
}

.option-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5em 0;
  cursor: pointer;
  transition: opacity 0.2s;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.option-item:last-child {
  border-bottom: none;
}

.option-item:hover {
  opacity: 0.8;
}

.option-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.option-text {
  color: #ffffff;
}

.option-icon {
  color: rgba(255, 255, 255, 0.8);
}

.pro-badge {
  background-color: #00bcd4;
  color: #000000;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  text-transform: uppercase;
}

.pro-item:hover {
  opacity: 0.7;
}
</style>